export default __webpack_public_path__ + "static/media/wulsage.32ae7e2e.png";